const authMethods = {
  password: { id: 'password', name: 'Password' },
  saml: { id: 'saml', name: 'SAML' },
};

export default authMethods;
